import { Badge } from "@/core/components/ui/badge";
import {
  REFERRAL_STATUS_TO_BADGE_VARIANT,
  REFFERRAL_STATUS_TO_SIDEBAR_TEXT,
} from "@/referrals/constants";
import { IReferral } from "@/referrals/referral";

interface SidebarBadgeProps {
  referral: IReferral;
}

export const SidebarBadge = ({ referral }: SidebarBadgeProps) => (
  <Badge
    variant={
      REFERRAL_STATUS_TO_BADGE_VARIANT[
        referral.status as keyof typeof REFERRAL_STATUS_TO_BADGE_VARIANT
      ]
    }
  >
    {
      REFFERRAL_STATUS_TO_SIDEBAR_TEXT[
        referral.status as keyof typeof REFFERRAL_STATUS_TO_SIDEBAR_TEXT
      ]
    }
  </Badge>
);
